import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from '@/hooks/use-toast';
import { isLiveStorePlan, storeDisplayName, storeProviderOf } from '@/lib/billing/storeBilling';
import type { SubscriptionLike } from '@/lib/quota/isPaidSubscription';

/** A live store plan cannot start a web checkout. Returns a function that
 *  tells the user to use the store and answers true when it blocked. */
export function useStoreCheckoutGuard(): (subscription: SubscriptionLike | null | undefined) => boolean {
  const { t } = useTranslation();
  return useCallback(
    (subscription) => {
      const provider = isLiveStorePlan(subscription) ? storeProviderOf(subscription) : null;
      if (!provider) return false;
      toast({
        title: t('billing.storeManagedCheckout', { store: storeDisplayName(provider) }),
        variant: 'destructive',
      });
      return true;
    },
    [t],
  );
}
